import { hotRank } from "@/mocks/portalData";

const tagStyle: Record<string, string> = {
  热: "bg-primary-500 text-background-50",
  沸: "bg-primary-700 text-background-50",
  新: "bg-accent-500 text-background-50",
};

export default function HotRank() {
  return (
    <section id="hot" className="bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-6 px-4 md:px-6 lg:grid-cols-[1.2fr_1fr]">
        <div className="flex flex-col gap-3 rounded-2xl border border-background-200/70 bg-background-50 p-5 md:p-7">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-primary-600">按热度排序 · TRENDING</p>
              <h2 className="mt-1 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
                实时热榜
              </h2>
            </div>
            <span className="flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-50 px-3 py-1.5 text-xs font-medium text-primary-700">
              <i className="ri-loop-left-line text-sm"></i>
              每 5 分钟刷新
            </span>
          </div>

          <ol className="mt-2 divide-y divide-background-200/60">
            {hotRank.map((r) => (
              <li key={r.rank}>
                <a
                  href="#feed"
                  className="group flex items-center gap-3 py-3 md:gap-4"
                >
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                      r.rank <= 3 ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-400"
                    }`}
                  >
                    {r.rank}
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="truncate text-sm font-medium text-foreground-800 group-hover:text-primary-700 md:text-base">
                      {r.title}
                    </p>
                    <p className="mt-0.5 text-xs text-foreground-400">{r.field}</p>
                  </div>
                  <span className={`inline-flex shrink-0 items-center whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-bold ${tagStyle[r.tag]}`}>
                    {r.tag}
                  </span>
                  <span className="hidden shrink-0 items-center gap-1 text-xs text-foreground-400 sm:flex">
                    <i className="ri-fire-line text-sm"></i>
                    {r.heat} 万
                  </span>
                </a>
              </li>
            ))}
          </ol>
        </div>

        <aside className="flex flex-col gap-4">
          <div className="rounded-2xl border border-background-200/70 bg-background-50 p-5 md:p-7">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 text-background-50">
                <i className="ri-question-mark text-lg"></i>
              </span>
              <h3 className="font-heading text-lg font-bold text-foreground-950">如何快速锁定一手来源？</h3>
            </div>
            <ol className="mt-5 space-y-4">
              {[
                { t: "看领域，锁定头部账号", d: "先进入对应分类，筛选持续产出、认证完整的博主。" },
                { t: "辨热度，找事件主线", d: "跟随热榜排序，关注讨论量飙升的话题源头。" },
                { t: "溯来源，回看原帖", d: "每一条内容都标有来源博主，可直达其主页复核。" },
              ].map((s, i) => (
                <li key={s.t} className="flex gap-3">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-100 text-xs font-bold text-primary-700">
                    {i + 1}
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">{s.t}</p>
                    <p className="mt-0.5 text-xs leading-relaxed text-foreground-500">{s.d}</p>
                  </div>
                </li>
              ))}
            </ol>
          </div>

          <div className="rounded-2xl border border-primary-200/70 bg-gradient-to-br from-primary-500 to-primary-700 p-5 text-background-50 md:p-7">
            <h3 className="font-heading text-lg font-bold">有可靠爆料线索？</h3>
            <p className="mt-2 text-sm leading-relaxed text-background-50/90">
              我们欢迎提供真实、可溯源的一手线索，审核通过后将按热度纳入对应分类推荐。
            </p>
            <a
              href="#faq"
              className="mt-4 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-4 py-2 text-sm font-medium text-primary-700 transition-colors hover:bg-background-100"
            >
              联系内容团队
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </aside>
      </div>
    </section>
  );
}